import { all, call, fork, put, takeLatest } from 'redux-saga/effects';

import { showErrorNotification } from '../actions/App';
import { getActiveDiversionsSuccess, getActiveDiversionsFailure } from '../actions/Diversion';
import * as diversionApi from '../api/Diversion';
import { GET_ACTIVE_DIVERSIONS_REQUEST } from '../constants/ActionTypes';

function* getActiveDiversions() {
  try {
    const { data } = yield call(diversionApi.getActiveDiversions);
    yield put(getActiveDiversionsSuccess(data));
  } catch (error) {
    yield put(getActiveDiversionsFailure(error));
    yield put(showErrorNotification(error.messages));
  }
}

export function* getActiveDiversionsSaga() {
  yield takeLatest(GET_ACTIVE_DIVERSIONS_REQUEST, getActiveDiversions);
}

export default function* rootSaga() {
  yield all([fork(getActiveDiversionsSaga)]);
}
